import React from 'react';

import { i18n } from '../../services/i18n';

function Empty() {
    return <div>{i18n.t('empty')}</div>;
}

export default Empty;
